
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 702","transform":"translate(-37 -99)"}},[_c('rect',{attrs:{"data-name":"Rectangle 2091","width":"22","height":"22","rx":"4","transform":"translate(37 99)","fill":"#7469d9"}}),_c('rect',{attrs:{"data-name":"Rectangle 2093","width":"18","height":"8","rx":"2","transform":"translate(39 101)","fill":"#42ddb3"}}),_c('rect',{attrs:{"data-name":"Rectangle 2094","width":"8","height":"8","rx":"4","transform":"translate(49 111)","fill":"#5d54b4"}}),_c('rect',{attrs:{"data-name":"Rectangle 2095","width":"18","height":"8","rx":"4","transform":"translate(39 111)","fill":"#4a4291"}}),_c('rect',{attrs:{"data-name":"Rectangle 2097","width":"10","height":"2","rx":"1","transform":"translate(43 114)","fill":"#42ddb3"}})])])
          )
        }
      }
    